module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-7.620388e8.png";